<template>
  <div>
    <div class="mt-4 mt-md-0">
      <page-header :page="page" />
    </div>

    <MatchMedia v-slot="{ mobile }">
      <filter-manager
        ref="filterComponent"
        v-model="filtersSelected"
        :class="['mb-4', { 'filter-mobile': mobile }]"
        :filters="filtersConfig"
        :open-advanced="openAdvanced"
        @search="search"
      >
        <template #header_advanced>
          <div class="row">
            <div class="col d-flex justify-content-end">
              <drop-down
                :items="handlerFilters"
                :title="handlerFilters[handlerFilterSelected].label"
                variant="rounded-dark"
              />
            </div>
          </div>
        </template>
      </filter-manager>
    </MatchMedia>

    <separator
      v-if="results.length > 0"
      class="my-3"
      text="Resultado de Referidos"
    />
    <row
      v-for="result in results"
      :key="result.admissionId"
      :allowed-go-to-record="allowedGoToStudentServiceRecord"
      :can-add-result-summary="canAddResultSummary"
      :centers="filters.centers"
      class="mb-3"
      :current-academic-year-id="currentAcademicYearId"
      :future-academic-year="futureAcademicYear"
      :has-pilot-permission="hasPilotPermission(result)"
      :value="result"
      @onShowVisitHistory="showHistory"
      @refreshReferralGrid="refreshReferralGrid"
    />

    <visit-details-history-modal
      :admission-id="visitHistory.admissionId"
      :is-open="visitHistory.show"
      @onClose="visitHistory.show = false"
    />

    <pagination
      v-if="showPagination"
      :data="pagination"
      @pagination-go-page="pageChanged"
    />
  </div>
</template>
<script>
import { MatchMedia } from 'vue-component-media-queries';
import Row from './Row';
import Pagination from 'pagination';
import ServiceTypes from '@/utils/shared/constants/serviceTypes';

import {
  getAcademicYears as _getAcademicYears,
  getAvailableMonths as _getAvailableMonths,
  getFutureAcademicYear as _getFutureAcademicYear,
  getCurrentAcademicYear as _getCurrentAcademicYear,
} from '@/modules/shared/academicyear.api';

import {
  getMunicipalities as _getMunicipalities,
  getCenters as _getCenters,
  getSchools as _getSchools,
} from '@/modules/shared/location.api';

import {
  getAdmissionStatus as _getAdmissionStatus,
  getAdmissionStatusReasons as _getAdmissionStatusReasons,
  getAdmissionReferralTypes as _getAdmissionReferralTypes,
  getServiceModalityTypes as _getServiceModalityTypes,
  getReferrals as _getReferrals,
} from '@/modules/shared/studentreferral.api';

import {
  getDisciplineTypes as _getDisciplineTypes,
  getTypePlaces as _getTypePlaces,
  getFrequencyType as _getFrequencyType,
  getTherapyDurationsForTherapies,
} from '@/modules/shared/code.api';

import {
  getProviderMunicipalities as _getProviderMunicipalities,
  getProviderLocationServices as _getProviderLocationServices,
  getProviderSpecialists as _getProviderSpecialists,
  getProvidersByAcademicyearId as _getProvidersByAcademicyearId,
  getProviderCenters as _getProviderCenters,
} from '@/modules/shared/provider.api';

import { getSupervisedInfo as _getSupervisedInfo } from '@/modules/provider/api';

import ThrpyReferralAlertTypes from '@/utils/shared/constants/referralAlertTypes';
import roles from '@/utils/constants/roles.js';
import VisitDetailsHistoryModal from './VisitDetailsHistory';
import storeMixin from '@/shared/mixins/storeGenerator';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';
import alertMixin from '@/mixins/alert.mixin.js';
const DEPR = 472;
export default {
  name: 'SearchReferral',
  components: {
    MatchMedia,
    Row,
    Pagination,
    VisitDetailsHistoryModal,
  },
  mixins: [storeMixin, alertMixin],
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Manejo de Referidos',
        routes: ['Inicio', 'Proveedor', 'Manejo de Referidos', 'Seguimiento'],
      },
      filters: {
        years: [],
        services: [],
        status: [],
        centers: [],
        municipalities: [],
        reasons: [],
        types: [],
        modalityTypes: [],
        providers: [],
        typePlaces: [],
        places: [],
        specialists: [],
        supervisedSpecialists: [],
        months: [],
        schools: [],
        frequencyTypes: [],
        therapyDurations: [],
      },
      filtersSelected: {},
      openAdvanced: false,
      handlerFilterSelected: 0,
      handlerFilterEnum: {
        standard: 0,
        alert: 1,
        advanced: 2,
      },
      canAddResultSummary: false,
      alertTypes: [
        {
          name:
            'Estudiantes con Estatus Egresados y Referidos desde el estatus de vinculado',
          id: 0,
        },
        { name: 'Estatus de Vinculaciones Iniciales', id: 1 },

        {
          name: 'Referidos con cambios de Definición de Servicios',
          id: 2,
        },
        { name: 'Vencimiento de Admisión', id: 3 },
        { name: 'Vencimiento de Servicio', id: 4 },
      ],
      companiesPilot: [],
      results: [],
      centers: [],
      pagination: {
        perPage: 15,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      visitHistory: {
        show: false,
        admissionId: null,
      },
      futureAcademicYear: null,
      currentAcademicYearId: null,
      isFromAvailabilityCalendar: false,
      allowedGoToStudentServiceRecord: false,
    };
  },
  computed: {
    ...mapGetters('$_user', ['fullProfile', 'companies']),
    isProvider() {
      return this.fullProfile?.companyid != null;
    },
    hasPilotPermission() {
      return (item) => {
        return this.companiesPilot.includes(item.companyId);
      };
    },
    hasMultipleCompanies() {
      const companies =
        this.fullProfile?.companyid != null ? this.fullProfile?.companyid : '';
      return companies.split(',').length > 1;
    },
    mustSearchInAdvancedMode() {
      return (!this.isAdmin && this.hasMultipleCompanies) || this.isSpecialist;
    },
    isAdmin() {
      return [
        roles.Administrador,
        roles.AdminProvider,
        roles.AdminSAEE,
        roles.AdminIL,
        roles.UMESRAdmin,
      ].includes(this.fullProfile?.role);
    },
    isSpecialist() {
      return this.fullProfile?.specialistId != null;
    },
    handlerFilters() {
      const { standard, alert, advanced } = this.handlerFilterEnum;
      return [
        {
          label: 'Estándar',
          click: () => this.changeFilterMode(standard),
        },
        { label: 'Alertas', click: () => this.changeFilterMode(alert) },
        {
          label: 'Avanzado',
          click: () => this.changeFilterMode(advanced),
        },
        { label: 'Lista de Espera', visible: false },
      ];
    },
    filtersConfig() {
      const { standard, alert, advanced } = this.handlerFilterEnum;

      let searchFast = [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filters.years,
          initialValue: this.currentAcademicYear(),
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-md-3',
          clearModelsOnUpdate: this.isProvider
            ? ['service', 'status', 'type', 'month', 'center']
            : [
                'service',
                'status',
                this.filters.providers.length > 1 ? 'provider' : '',
                'type',
                'month',
                'center',
              ],
          onChanged: this.onYearChanged,
        },
        {
          name: 'month',
          component: 'CustomDropDown',
          placeholder: 'Seleccione',
          options: this.filters.months,
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          visible:
            this.handlerFilterSelected == advanced ||
            this.handlerFilterSelected == alert,
          validations: this.isMonthRequired ? 'required' : null,
          error: this.isMonthRequired ? 'El mes es requerido.' : null,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE o Número de Referido',
          leftIcon: true,
          icon: 'fas fa-search color-primary-2',
        },
      ];
      return this.handlerFilterSelected == alert
        ? searchFast.concat([
            {
              name: 'alerts',
              component: 'CustomDropDown',
              options: this.alertTypes,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Alertas:',
              isAdvanced: true,
              class: 'col-md-3',
              placeholder: 'Seleccione',
            },
            {
              name: 'service',
              component: 'CustomDropDown',
              options: this.filters.services,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Servicio:',
              isAdvanced: true,
              class: 'col-md-3',
              placeholder: 'Seleccione',
            },
            {
              name: 'status',
              component: 'CustomDropDown',
              options: this.filters.status,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Estatus:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              onChanged: this.onStatusChanged,
              clearModelsOnUpdate: ['reason'],
            },
          ])
        : searchFast.concat([
            {
              name: 'service',
              component: 'CustomDropDown',
              options: this.filters.services,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Servicio:',
              isAdvanced: true,
              class: 'col-md-3',
              placeholder: 'Seleccione',
            },
            {
              name: 'status',
              component: 'CustomDropDown',
              options: this.filters.status,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Estatus:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              onChanged: this.onStatusChanged,
              clearModelsOnUpdate: ['reason'],
            },
            {
              name: 'reason',
              component: 'CustomDropDown',
              options: this.filters.reasons,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Razón:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              disabled: ['status'],
            },
            {
              name: 'type',
              component: 'CustomDropDown',
              options: this.filters.types,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Tipo de Referido:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
            },
            {
              name: 'modalityType',
              component: 'CustomDropDown',
              options: this.filters.modalityTypes,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Modalidad:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              visible: this.handlerFilterSelected == standard,
              class: 'col-md-3',
            },
            {
              name: 'frequencyType',
              component: 'CustomDropDown',
              options: this.filters.frequencyTypes,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Frecuencia:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              visible: this.handlerFilterSelected == standard,
              class: 'col-md-3',
            },
            {
              name: 'duration',
              component: 'CustomDropDown',
              options: this.filters.therapyDurations,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Duración:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              visible: this.handlerFilterSelected == standard,
              class: 'col-md-3',
            },
            {
              name: 'provider',
              component: 'CustomDropDown',
              options: this.filters.providers,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Proveedor:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              visible: this.handlerFilterSelected == advanced,
              onChanged: this.onProviderChanged,
              clearModelsOnUpdate: ['center'],
              disabled: this.isProvider && this.filters.providers.length < 2,
              validations: this.mustSearchInAdvancedMode ? 'required' : '',
            },
            {
              name: 'center',
              component: 'CustomDropDown',
              options: this.filters.centers,
              disabled:
                this.handlerFilterSelected == advanced &&
                this.filtersSelected.provider?.id == null,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Centro:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              onChanged: this.onCenterChanged,
              clearModelsOnUpdate: this.isSpecialist
                ? ['municipality', 'school', 'typePlace']
                : ['municipality', 'school', 'specialist', 'typePlace'],
            },
            {
              name: 'municipality',
              component: 'CustomDropDown',
              options: this.filters.municipalities,
              initialValue: null,
              disabled: (this.handlerFilterSelected ==
                this.handlerFilterEnum.advanced &&
                this.filtersSelected.provider?.id == null) || ['center'],
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Municipio:',
              placeholder: 'Seleccione',
              isAdvanced: true,
              class: 'col-md-3',
              onChanged: this.onMunicipalityChanged,
              clearModelsOnUpdate: this.isSpecialist
                ? ['school', 'typePlace']
                : ['school', 'specialist', 'typePlace'],
            },
            {
              name: 'typePlace',
              component: 'CustomDropDown',
              options: this.filters.typePlaces,
              disabled: this.filtersSelected.provider?.id == null,
              fieldName: 'name',
              fieldKey: 'id',
              placeholder: 'Seleccione',
              label: 'Tipo de Lugar:',
              isAdvanced: true,
              class: 'col-md-3',
              visible: this.handlerFilterSelected == advanced,
              onChanged: this.onTypePlaceChanged,
              clearModelsOnUpdate: ['specialist', 'place'],
            },
            {
              name: 'place',
              component: 'CustomDropDown',
              options: this.filters.places,
              disabled:
                this.filtersSelected.provider?.id == null ||
                this.filters?.places?.length == 1,
              fieldName: 'name',
              fieldKey: 'id',
              placeholder: 'Seleccione',
              label: 'Lugar:',
              clearModelsOnUpdate: ['specialist'],
              isAdvanced: true,
              class: 'col-md-3',
              visible: this.handlerFilterSelected == advanced,
              onChanged: this.onPlaceChanged,
            },
            {
              name: 'specialist',
              component: 'CustomDropDown',
              options: this.filters.specialists,
              disabled:
                (this.filtersSelected.provider?.id == null ||
                  this.isSpecialist) &&
                this.filtersSelected.provider?.id != DEPR,
              fieldName: 'name',
              fieldKey: 'id',
              placeholder: 'Seleccione',
              label: 'Especialista:',
              isAdvanced: true,
              class: 'col-md-3',
              visible: this.handlerFilterSelected == advanced,
            },
            {
              name: 'supervisedSpecialist',
              component: 'CustomDropDown',
              options: this.filters.supervisedSpecialists,
              label: 'Especialista Supervisado:',
              placeholder: 'Seleccione especialista supervisado',
              fieldName: 'name',
              fieldKey: 'id',
              clearable: true,
              class: 'col-md-3',
              isAdvanced: true,
              visible:
                this.handlerFilterSelected == advanced && this.isSpecialist,
            },
            {
              name: 'school',
              component: 'CustomDropDown',
              options: this.filters.schools,
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Escuela:',
              isAdvanced: true,
              class: 'col-md-3',
              visible: this.handlerFilterSelected == standard,
              disabled: ['municipality'],
              placeholder: 'Seleccione',
            },
            {
              name: 'coordinatedService',
              component: 'CustomDropDown',
              options: [
                { id: true, name: 'Sí' },
                { id: false, name: 'No' },
              ],
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Servicio Coordinado:',
              isAdvanced: true,
              class: 'col-md-3',
              visible:
                this.handlerFilterSelected == standard ||
                this.handlerFilterSelected == advanced,
              placeholder: 'Seleccione',
              clearable: true,
            },
            {
              name: 'hasPlan',
              component: 'CustomDropDown',
              options: [
                { id: true, name: 'Sí' },
                { id: false, name: 'No' },
              ],
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Plan Sometido',
              isAdvanced: true,
              class: 'col-md-1.5',
              visible: this.handlerFilterSelected == standard,
              placeholder: 'Seleccione',
              clearable: true,
            },
            {
              name: 'hasAdmissionNote',
              component: 'CustomDropDown',
              options: [
                { id: true, name: 'Sí' },
                { id: false, name: 'No' },
              ],
              fieldName: 'name',
              fieldKey: 'id',
              label: 'Nota Admisión',
              isAdvanced: true,
              class: 'col-md-1.5',
              visible: this.handlerFilterSelected == standard,
              placeholder: 'Seleccione',
              clearable: true,
            },
          ]);
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.perPage;
    },
    handlerFilterSelectedStored() {
      return this.$store.state.moduleGenerated.data?.SearchReferral
        ?.handlerFilterSelected;
    },
    currentFiltersSelected() {
      const currentSelected = this.filtersSelected;
      return {
        center: currentSelected.center,
        municipality: currentSelected.municipality,
        school: currentSelected.school,
        typePlace: currentSelected.typePlace,
        place: currentSelected.place,
        specialist: currentSelected.specialist,
        provider: currentSelected.provider,
        coordinatedService: currentSelected.coordinatedService,
        hasPlan: currentSelected.hasPlan,
        hasAdmissionNote: currentSelected.hasAdmissionNote,
      };
    },
    isMonthRequired() {
      return (
        this.filtersSelected.alerts?.id ==
        ThrpyReferralAlertTypes.serviceChangeDefinition
      );
    },
  },
  watch: {
    selectedAcademicYear() {
      this.resetFilters();
    },
    async handlerFilterSelected(newValue) {
      const currentSelected = this.currentFiltersSelected;

      this.filtersSelected.provider = this.isProvider
        ? this.filters.providers.find((x) => x.id == this.fullProfile.companyid)
        : null;

      if (this.isProvider) {
        await _getProviderLocationServices(
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id,
          this.filtersSelected.center?.id,
          this.filtersSelected.municipality?.id
        ).then(({ data }) => (this.filters.places = data));

        if (this.filters?.places?.length == 1) {
          this.filtersSelected.place = this.filters?.places[0];
        }
      }
      if (this.handlerFilterSelectedStored !== newValue) {
        this.resetFilters();
      }

      if (newValue == this.handlerFilterEnum.advanced) {
        await this.loadAdvancedFilters();
      } else if (newValue == this.handlerFilterEnum.standard) {
        await this.loadStandardFilters();
      } else if (newValue == this.handlerFilterEnum.alert) {
        await this.loadAlertsFilters();
      }

      this.setSelectedFilters(currentSelected);
    },
  },
  async created() {
    await this.recoveryData();
  },
  async mounted() {
    Promise.all([this.getFrequencyTypes(), this.getTherapyDurations()]);

    await _getAcademicYears().then(({ data }) => (this.filters.years = data));

    await this.getParameters();

    if (
      this.handlerFilterSelectedStored === undefined ||
      this.handlerFilterSelectedStored === this.handlerFilterEnum.standard
    )
      await this.loadStandardFilters();

    const reload = _.get(this.$route, 'params.fromData.reload', false);
    if (reload || this.isFromAvailabilityCalendar) {
      this.$refs.filterComponent.search({ page: this.pagination.currentPage });
    }
    this.forceToSearchInAdvancedMode();
    await this.getAllowedGoToStudentServiceRecordSysParam();
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isFromAvailabilityCalendar =
        from.name === 'SpecialistAvailabilityCalendar' ||
        from.name === 'SpecialistAvailabilityCalendarTransfer' ||
        from.name === 'admissionManagement';
    });
  },
  methods: {
    async getAllowedGoToStudentServiceRecordSysParam() {
      const { data } = await _getSysparameterByNames({
        parameterNames: ['AllowedGoToStudentServiceRecord'],
      });

      this.allowedGoToStudentServiceRecord =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    forceToSearchInAdvancedMode() {
      if (this.mustSearchInAdvancedMode) {
        if (
          this.handlerFilterSelected !== this.handlerFilterEnum.advanced ||
          !this.$refs.filterComponent.advanced
        ) {
          this.$refs.filterComponent.advanced = true;
          this.openAdvanced = true;
          this.changeFilterMode(this.handlerFilterEnum.advanced);
          return true;
        }
      } else if (this.userHasPermissions('level.location')) {
        this.changeFilterMode(this.handlerFilterEnum.advanced);
        this.openAdvanced = true;
      }
    },
    showHistory(admissionId) {
      this.visitHistory = {
        show: true,
        admissionId,
      };
    },
    refreshReferralGrid() {
      this.pageChanged(this.pagination.currentPage);
    },
    pageChanged(page) {
      this.$refs.filterComponent.search({ page });
      this.pagination.currentPage = page;
    },
    changeFilterMode(mode) {
      this.handlerFilterSelected = mode;
      this.resetFilters();
    },
    resetFilters() {
      this.filtersSelected.center = null;
      this.filtersSelected.municipality = null;
      this.filtersSelected.supervisedSpecialist = null;
      this.filtersSelected.month = null;
      this.filtersSelected.service = null;
      this.filtersSelected.status = null;
      this.filtersSelected.type = null;
      this.filtersSelected.modalityType = null;
      this.filtersSelected.alerts = null;
      this.filtersSelected.coordinatedService = null;
      this.filtersSelected.hasPlan = null;
      this.filtersSelected.hasAdmissionNote = null;
    },
    async getFrequencyTypes() {
      const { data } = await _getFrequencyType();
      this.filters.frequencyTypes = data;
    },
    async getTherapyDurations() {
      const { data } = await getTherapyDurationsForTherapies();
      this.filters.therapyDurations = data;
    },
    async search(data) {
      if (this.forceToSearchInAdvancedMode()) {
        return;
      }

      if (this.isMonthRequired && !this.filtersSelected.month) {
        return;
      }

      if (data) {
        this.openAdvanced = this.$refs.filterComponent.advanced;
        //Set current Page in 1 when is searching
        //For paging this statment is ignoredbf9
        if (data.page == undefined) {
          this.pagination.currentPage = 1;
        }

        let startRowIndex = 1;
        if (this.pagination.currentPage > 1) {
          startRowIndex = this.pagination.currentPage;
        }

        _getReferrals({
          fiscalYear: data.academicYear?.id,
          discipline: data.type?.id,
          statusId: data.status?.id,
          serviceId: data.service?.id,
          centerId: data.center?.id,
          municipalityId: data.municipality?.id,
          schoolId: data.school?.id,
          admissionStatusReasonId: data.reason?.id,
          admissionStatusId: data.status?.id,
          referralTypeId: data.type?.id,
          modalityTypeId: data.modalityType?.id,
          reasonId: data.reason?.id,
          searchMode: this.handlerFilterSelected,
          searchText: data.sie,
          thrpyReferralAlertTypes: !data.alerts
            ? ThrpyReferralAlertTypes.unSet
            : data.alerts?.id,
          //Advanced Options
          month: data.month?.id,
          providerId: data.provider?.id,
          locationTypeCd: data.typePlace?.id,
          locationFiscalYearId: data.place?.id,
          specialistId: data.supervisedSpecialist?.id || data.specialist?.id,
          coordinatedService: data.coordinatedService?.id,
          frequencyTypeId: data.frequencyType?.id,
          therapyDurationId: data.duration?.id,
          hasPlan: data.hasPlan?.id,
          hasAdmissionNote: data.hasAdmissionNote?.id,
          pageIndex: startRowIndex,
          pageSize: this.pagination.perPage,
        }).then(({ data }) => {
          this.results = data.data;
          this.pagination = {
            count: data.count,
            currentPage: data.currentPage,
            pageCount: data.pageCount,
            totalItemCount: data.totalItemCount,
            perPage: 15,
          };
        });
      }
    },
    async loadStandardFilters() {
      if (this.filters.status.length == 0)
        await _getAdmissionStatus().then(
          ({ data }) => (this.filters.status = data)
        );

      if (this.filters.types.length == 0)
        await _getAdmissionReferralTypes().then(
          ({ data }) => (this.filters.types = data)
        );

      if (this.filters.modalityTypes.length == 0)
        await _getServiceModalityTypes().then(
          ({ data }) => (this.filters.modalityTypes = data)
        );

      if (this.filters.services.length == 0)
        await _getDisciplineTypes(ServiceTypes.Therapy, 2).then(
          ({ data }) => (this.filters.services = data)
        );

      const currentSelected = this.currentFiltersSelected;

      await this.loadCenters();
      this.setSelectedFilters({ center: currentSelected.center });

      await this.loadMunicipalities();

      await _getSchools({
        academicYearId: this.filtersSelected.academicYear.id,
      }).then(({ data }) => (this.filters.schools = data));

      await this.getProfileFilters();

      this.setSelectedFilters({
        municipality: currentSelected.municipality,
        school: currentSelected.school,
      });
    },
    async loadAdvancedFilters() {
      this.loadMonths();

      if (this.filters.typePlaces.length == 0) {
        _getTypePlaces(7).then(({ data }) => (this.filters.typePlaces = data));
      }

      await this.getProfileFilters();
    },
    async loadAlertsFilters() {
      this.loadMonths();
    },
    async loadMonths() {
      if (this.filtersSelected.academicYear != null) {
        await _getAvailableMonths(this.filtersSelected.academicYear.id).then(
          ({ data }) => {
            this.filters.months = data;
          }
        );
      }
    },
    async setSelectedFilters(currentSelected) {
      if (currentSelected.municipality) {
        await this.loadMunicipalities();
        this.filtersSelected.municipality = currentSelected.municipality;
      }

      if (currentSelected.school)
        this.filtersSelected.school = currentSelected.school;

      if (currentSelected.typePlace)
        this.filtersSelected.typePlace = currentSelected.typePlace;

      if (currentSelected.place)
        this.filtersSelected.place = currentSelected.place;

      if (currentSelected.specialist)
        this.filtersSelected.specialist = currentSelected.specialist;

      if (currentSelected.provider)
        this.filtersSelected.provider = currentSelected.provider;

      if (currentSelected.coordinatedService)
        this.filtersSelected.coordinatedService =
          currentSelected.coordinatedService;

      this.$nextTick(() => {
        if (currentSelected.center)
          this.filtersSelected.center = currentSelected.center;
      });
    },
    async getProfileFilters() {
      if (this.isSpecialist) {
        this.filters.providers = this.companies;

        if (this.filters.providers.length == 1) {
          this.filtersSelected.provider = this.companies[0];
          this.filtersSelected.provider.disabled = true;
        }

        this.filtersSelected.specialist = {
          id: Number(this.fullProfile.specialistId),
          name: this.fullProfile.givenname,
        };

        await this.onProviderChanged();
      } else {
        await _getProvidersByAcademicyearId(
          this.filtersSelected.academicYear?.id
        ).then(async ({ data }) => {
          this.filters.providers = data;
          if (this.isProvider && this.filters.providers.length === 1) {
            this.filtersSelected.provider = this.filters.providers[0];
            await this.onProviderChanged();
          }
        });
      }
    },
    async loadCenters() {
      if (this.handlerFilterSelected == this.handlerFilterEnum.standard) {
        await _getCenters({
          academicYearId: this.filtersSelected.academicYear.id,
        }).then(({ data }) => (this.filters.centers = data));
      } else {
        await _getProviderCenters(
          this.filtersSelected.academicYear.id,
          this.filtersSelected.provider?.id
        ).then(({ data }) => (this.filters.centers = data));
      }
    },
    async loadMunicipalities() {
      const hasCenterSelected = this.filtersSelected.center?.id > 0;
      if (!hasCenterSelected) return;

      if (this.handlerFilterSelected == this.handlerFilterEnum.standard) {
        await _getMunicipalities({
          academicYearId: this.filtersSelected.academicYear.id,
          centerId: this.filtersSelected.center?.id,
        }).then(({ data }) => (this.filters.municipalities = data));
      } else {
        await _getProviderMunicipalities(
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id,
          this.filtersSelected.center?.id
        ).then(({ data }) => (this.filters.municipalities = data));
      }
    },
    async loadSupervisedSpecialist() {
      if (this.isSpecialist && this.filtersSelected.specialist?.id > 0) {
        const { data } = await _getSupervisedInfo(
          this.filtersSelected.specialist?.id,
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id
        );
        const supervisedSpecialists = (data || []).map((x) => ({
          id: x.supervisedId,
          name: x.specialistName,
        }));
        this.filters.supervisedSpecialists = supervisedSpecialists;
      }
    },
    async onYearChanged() {
      if (this.filters.providers.length > 1 && !this.isProvider) {
        this.filtersSelected.provider = null;
      }
      if (
        this.handlerFilterSelected == this.handlerFilterEnum.advanced ||
        this.handlerFilterSelected == this.handlerFilterEnum.alert
      ) {
        this.loadMonths();
      }
    },
    async onProviderChanged() {
      this.filtersSelected.place = null;
      if (this.filtersSelected.provider?.id) {
        const centerId = this.filtersSelected.center?.id;
        const currentSelected = this.currentFiltersSelected;

        await this.loadCenters();
        await this.onCenterChanged();
        await this.loadSupervisedSpecialist();

        await _getProviderLocationServices(
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id,
          this.filtersSelected.center?.id,
          this.filtersSelected.municipality?.id
        ).then(({ data }) => (this.filters.places = data));

        if (this.filters?.places?.length == 1) {
          this.filtersSelected.place = this.filters?.places[0];
        }

        if (centerId > 0)
          this.setSelectedFilters({
            ...currentSelected,
            center: this.filters.centers.find((x) => x.id === centerId),
          });
      }
    },
    onStatusChanged() {
      if (this.filtersSelected.status?.id != null) {
        _getAdmissionStatusReasons(this.filtersSelected.status?.id).then(
          ({ data }) => (this.filters.reasons = data)
        );
      }
    },
    async onCenterChanged() {
      const centerId = this.filtersSelected.center?.id;

      if (this.handlerFilterSelected == this.handlerFilterEnum.advanced) {
        const academicyearId = this.filtersSelected.academicYear?.id;
        const providerId = this.filtersSelected.provider?.id;

        await _getProviderLocationServices(
          academicyearId,
          providerId,
          centerId
        ).then(({ data }) => (this.filters.places = data));

        if (this.filters?.places?.length == 1) {
          this.filtersSelected.place = this.filters?.places[0];
        }

        await _getProviderSpecialists(
          academicyearId,
          providerId,
          centerId
        ).then(({ data }) => {
          let ordened = data.sort((item1, item2) =>
            item1.name.localeCompare(item2.name)
          );
          this.filters.specialists = ordened;
        });
      }
      if (centerId > 0) await this.loadMunicipalities();
      else this.filters.municipalities = [];
    },
    async onMunicipalityChanged() {
      if (this.handlerFilterSelected == this.handlerFilterEnum.advanced) {
        await _getProviderLocationServices(
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id,
          this.filtersSelected.center?.id,
          this.filtersSelected.municipality?.id
        ).then(({ data }) => (this.filters.places = data));

        if (this.filters?.places?.length == 1) {
          this.filtersSelected.place = this.filters?.places[0];
        }

        await _getProviderSpecialists(
          this.filtersSelected.academicYear?.id,
          this.filtersSelected.provider?.id,
          this.filtersSelected.center?.id,
          this.filtersSelected.municipality?.id
        ).then(({ data }) => (this.filters.specialists = data));
      } else if (
        this.handlerFilterSelected == this.handlerFilterEnum.standard
      ) {
        _getSchools({
          academicYearId: this.filtersSelected.academicYear.id,
          municipalityId: this.filtersSelected.municipality.id,
        }).then(({ data }) => {
          this.filters.schools = data;
        });
      }
    },
    onTypePlaceChanged() {
      _getProviderLocationServices(
        this.filtersSelected.academicYear?.id,
        this.filtersSelected.provider?.id,
        this.filtersSelected.center?.id,
        this.filtersSelected.municipality?.id,
        this.filtersSelected.typePlace?.id
      ).then(({ data }) => (this.filters.places = data));

      if (this.filters?.places?.length == 1) {
        this.filtersSelected.place = this.filters?.places[0];
      }

      _getProviderSpecialists(
        this.filtersSelected.academicYear.id,
        this.filtersSelected.provider?.id,
        this.filtersSelected.center?.id,
        this.filtersSelected.municipality?.id,
        this.filtersSelected.typePlace?.id
      ).then(({ data }) => (this.filters.specialists = data));
    },
    onPlaceChanged() {
      _getProviderSpecialists(
        this.filtersSelected.academicYear?.id,
        this.filtersSelected.provider?.id,
        this.filtersSelected.center?.id,
        this.filtersSelected.municipality?.id,
        this.filtersSelected.typePlace?.id,
        this.filtersSelected.place?.id
      ).then(({ data }) => (this.filters.specialists = data));
    },
    async getParameters() {
      const { data: currentAcademicYear } = await _getCurrentAcademicYear();
      this.currentAcademicYearId = currentAcademicYear.id;
      const { data: sysParameters } = await _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.AddViewInterventionPlanToFutureYear,
          sysparameterByNames.ReferralResultSummary,
          sysparameterByNames.SpecialistAvailabilityCalendarPilot,
        ],
      });
      this.canAddResultSummary =
        sysParameters.find(
          (x) => x.name == sysparameterByNames.ReferralResultSummary
        ).staticValue == 'True';

      if (
        sysParameters.find(
          (x) =>
            x.name == sysparameterByNames.AddViewInterventionPlanToFutureYear
        ).staticValue == 'True'
      ) {
        const { data: futureAcademicYear } = await _getFutureAcademicYear();
        this.futureAcademicYear = futureAcademicYear;
      } else {
        const { data: currentAcademicYear } = await _getCurrentAcademicYear();
        this.futureAcademicYear = currentAcademicYear;
      }

      const companiesPilot = sysParameters
        .find(
          (x) =>
            x.name == sysparameterByNames.SpecialistAvailabilityCalendarPilot
        )
        .staticValue.split(',');
      this.companiesPilot = companiesPilot.map((x) => {
        return Number(x);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-mobile ::v-deep {
  button.success {
    width: 206px;
  }
}
</style>
